import LoanRelatedBlock from './LoanRelatedBlock'
import LoanRelatedCardBlock from './LoanRelatedCardBlock'

export { LoanRelatedBlock, LoanRelatedCardBlock }
